// Shared configuration constants for Tasks components

export const priorityConfig = {
  pilny: { bg: 'var(--danger-light)', text: 'var(--danger)', label: '🔴 Pilny', border: 'var(--danger-light)' },
  wysoki: { bg: 'var(--warning-light)', text: 'var(--warning)', label: '🟠 Wysoki', border: 'var(--warning-light)' },
  normalny: { bg: 'var(--info-light)', text: 'var(--info)', label: '🔵 Normalny', border: 'var(--info-light)' },
  niski: { bg: 'var(--success-light)', text: 'var(--success)', label: '🟢 Niski', border: 'var(--success-light)' }
};

export const statusConfig = {
  nowe: { icon: '⚪', color: 'var(--text-muted)', label: 'Nowe', bg: 'var(--bg)' },
  w_trakcie: { icon: '🔵', color: 'var(--info)', label: 'W trakcie', bg: 'var(--info-light)' },
  zakonczone: { icon: '✅', color: 'var(--success)', label: 'Zakończone', bg: 'var(--success-light)' },
  anulowane: { icon: '❌', color: 'var(--danger)', label: 'Anulowane', bg: 'var(--danger-light)' }
};

export const categoryConfig = {
  dzis: { icon: '📅', label: 'Dziś', color: 'var(--danger)', bg: 'var(--danger-light)' },
  jutro: { icon: '📆', label: 'Jutro', color: 'var(--orange)', bg: 'var(--warning-light)' },
  tydzien: { icon: '📋', label: 'Ten tydzień', color: 'var(--info)', bg: 'var(--info-light)' },
  miesiac: { icon: '🗓️', label: 'Ten miesiąc', color: 'var(--purple)', bg: 'var(--purple-light)' },
  kiedys: { icon: '♾️', label: 'Kiedyś', color: 'var(--text-muted)', bg: 'var(--border)' }
};
